<app-form-master [form]="form">
  <div class="form-row">
    <div class="field-wrapper">
      <app-input-field
        [label]="'LABEL.TITLE' | translate"
        fieldId="attachment_title"
        [placeholder]="'PLACEHOLDER.ENTER_TITLE' | translate"
        [fieldControl]="form.get(formKeys.TITLE)"
      >
      </app-input-field>
    </div>
  </div>

  <div class="form-row">
    <div class="field-wrapper">
      <app-textarea-field
        [label]="'LABEL.DESCRIPTION' | translate"
        fieldId="attachment_description"
        [placeholder]="'PLACEHOLDER.ENTER_DESCRIPTION' | translate"
        [fieldControl]="form.get(formKeys.DESCRIPTION)"
        [maxlength]="3000"
      >
      </app-textarea-field>
    </div>
  </div>
</app-form-master>

<div class="actions">
  <button
    type="button"
    class="action cancel-edit-action"
    (click)="cancelEditing()"
    trackable
    [trackingObject]="trackingObject"
    [trackingAction]="cancelTapped"
  >
    {{ 'ACTION.CANCEL' | translate }}
  </button>

  <button
    type="button"
    class="action save-edit-action"
    (click)="saveEditingAttachment()"
    trackable
    [trackingObject]="trackingObject"
    [trackingAction]="saveTapped"
  >
    {{ 'ACTION.SAVE' | translate }}
  </button>
</div>
